export default __webpack_public_path__ + "static/media/AssgardLogo.9b578738.png";